import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,getKCISData} from '../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import { PlusOutlined,CloseOutlined,FileImageOutlined,VideoCameraOutlined } from '@ant-design/icons';
import { compose, withProps, withHandlers } from "recompose"
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps"

import axios from 'axios';



const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}



class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {			
			payee_list: [],
			category_details: [],
			loading: false,		
			student_list: [],
			selectedMarker: false,
			student_list: [],	
			map_student: [],
			show_map_model:false
		}
		this.goBack = this.goBack.bind(this);
	}
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			const params = new Proxy(new URLSearchParams(window.location.search), {
			    get: (searchParams, prop) => searchParams.get(prop),
			 });
			if(params.t!=null && params.s!=null){
				let token = params.t;
				let erp_id = params.s;
				var app = {token:token,erp_id:erp_id}
				var new_id = erp_id.split('_');
				getKCISData('auth/verify_token',app).then((result) => {
					let responseJson = result;
					if(responseJson){
						if(result['status'] == 200){
							localStorage.setItem('schoolData',JSON.stringify(responseJson));
							localStorage.setItem("app_token",params.t);
							var erp_id = result['data'][0]['erp_id'];
							var erp_type = erp_id.split('_');
							localStorage.setItem("erp_id",erp_id);
							localStorage.setItem("erp_type",erp_type[0]);
							window.location.reload(false);
						}
					}
				});
			}
		}else{
			const params = new Proxy(new URLSearchParams(window.location.search), {
			    get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.t!=null && params.s!=null){
				var app_token = localStorage.getItem("app_token");
				var check_id = localStorage.getItem("erp_id");
				if(params.t != app_token || check_id!=params.s){
					let token = params.t;
					let erp_id = params.s;
					var app = {token:token,erp_id:erp_id}
					var new_id = erp_id.split('_');
					getKCISData('auth/verify_token',app).then((result) => {
						let responseJson = result;
						if(responseJson){
							if(result['status'] == 200){
								localStorage.setItem('schoolData',JSON.stringify(responseJson));
								localStorage.setItem("app_token",params.t);
								var erp_id = result['data'][0]['erp_id'];
								var erp_type = erp_id.split('_');
								localStorage.setItem("erp_id",erp_id);
								localStorage.setItem("erp_type",erp_type[0]);
								window.location.reload(false);
							}
						}
					});
				}
			}
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {user_id : user_id,school_id:school_id}			
			getData('erp/map_student_details_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							student_list: result['data'],
						});
					}else{
						this.setState({
							student_list: [],
						});
					}
				}
			});	
		}
	}
    
	handleClick = (marker, event) => {
		this.setState({ selectedMarker: marker })
	}
 
    handleChange = ({ fileList }) => this.setState({ fileList });
	
	goBack(){
		window.location.href = '/expenses/index';
	}
	
	updatePositions=(p_array)=>{
		var student_array=Array();
		var student_list = this.state.student_list;
		p_array.forEach(cp => {
			student_list.forEach(st => {
				if(st.latitude==cp.latitude){
					student_array.push({
						name  : st.name
					});
				}
			});
		});
		this.setState({ map_student: student_array, show_map_model:true })
	}
	
		
	handleOk = e => {
		this.setState({
			show_map_model: false,
		})
	}

	handleCancel = e => {
		this.setState({
			show_map_model: false,
		})
	}
	
	render()
	{
	const { MarkerClusterer } = require("react-google-maps/lib/components/addons/MarkerClusterer");
	const MapWithAMarkerClusterer = compose(
	  withProps({
		googleMapURL: "https://maps.googleapis.com/maps/api/js?key=&v=3.exp&libraries=geometry,drawing,places",
		loadingElement: <div style={{ height: `100%` }} />,
		containerElement: <div style={{ height: `400px` }} />,
		mapElement: <div style={{ height: `100%` }} />,
	  }),
	  withHandlers({
		onMarkerClustererClick: () => (markerClusterer) => {
		    const clickedMarkers = markerClusterer.getMarkers()
		    //console.log(`Current clicked markers length: ${clickedMarkers.length}`)
		    var p_array=Array();
			for(var i=0;i<clickedMarkers.length;i++){
				var position = JSON.stringify(clickedMarkers[i].position);
				var gpos = JSON.parse(position);
				const index = p_array.findIndex((cp) => cp.latitude === gpos.lat);
				if(index<0){
					p_array.push({
						latitude  : gpos.lat,
						longitude : gpos.lng
					});
				}
			}
			this.updatePositions(p_array);			
		},
	  }),
	  withScriptjs,
	  withGoogleMap
    )(props =>
		  <GoogleMap
			defaultZoom={9}
			defaultCenter={{ lat: 17.3850, lng: 78.4867 }}
		  >
			<MarkerClusterer
			  onClick={props.onMarkerClustererClick}
			  averageCenter
			  enableRetinaIcons
			  gridSize={60}
			>
			  {props.markers.map(marker => (
				<Marker
				  key={marker.id}
				  position={{ lat: marker.latitude, lng: marker.longitude }}
				/>
			  ))}
			</MarkerClusterer>
		  </GoogleMap>
	);

	
			
		return (
		
			
			<div class="mobile_view map_model">
			
			<Modal 
				 title="Student List"
				 visible={this.state.show_map_model}
				 className="map_model"
				 onOk={this.handleOk}
				 onCancel={this.handleCancel}
				>
				<div class="student_box">
					{this.state.map_student.map((list,index) => (
						  <div class="student_list">
						  {index+1}. {list.name}
						  </div>
					))}
				</div>
			</Modal>
			
			<div class="row bred">
				<div class="col-md-12">
				<div class="card">
				<div class="card-body">
					<h4 class="page-title"> 
						<i class="mdi mdi-apple-keyboard-command title_icon"></i> Heat Map
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item">
									<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
									<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
									</a>
								</li>
								<li class="breadcrumb-item"> Heat Map</li>
							</ol>
						</div>
					</h4>
				</div>
				</div>
				</div>
			</div>	
			
			<div id="main" class="bg-off">
         <div class="row">
		  
            
			 <div class="col s12 m12 ex-padd">
            <div class="container view-Profile child-profile">
			   <div class="col s12 m12 mb-20 iq-card card card-content iq-card">
                  <section class="invoice-list-wrapper section food mh-500">
				   <MapWithAMarkerClusterer markers={this.state.student_list}/>
                  </section>
               </div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
